module.exports = __webpack_public_path__ + "static/media/UnitStandardUpload_Template.65840c42.xlsx";